import { render, staticRenderFns } from "./PaymentsMethods.vue?vue&type=template&id=84678132&lang=pug&"
import script from "./PaymentsMethods.vue?vue&type=script&lang=js&"
export * from "./PaymentsMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports